import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const cardStackDefaultVariants = {
  "itemOverflow": "hidden",
  "itemSurface": "default"
}
const cardStackCompoundVariants = []

const cardStackSlotNames = [
  [
    "stack",
    "card-stack__stack"
  ],
  [
    "item",
    "card-stack__item"
  ],
  [
    "content",
    "card-stack__content"
  ]
]
const cardStackSlotFns = /* @__PURE__ */ cardStackSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, cardStackDefaultVariants, getSlotCompoundVariant(cardStackCompoundVariants, slotName))])

const cardStackFn = memo((props = {}) => {
  return Object.fromEntries(cardStackSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const cardStackVariantKeys = [
  "itemOverflow",
  "itemSurface"
]
const getVariantProps = (variants) => ({ ...cardStackDefaultVariants, ...compact(variants) })

export const cardStack = /* @__PURE__ */ Object.assign(cardStackFn, {
  __recipe__: false,
  __name__: 'cardStack',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: cardStackVariantKeys,
  variantMap: {
  "itemOverflow": [
    "hidden",
    "visible"
  ],
  "itemSurface": [
    "default",
    "plain"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, cardStackVariantKeys)
  },
  getVariantProps
})